import { useEffect, useRef } from "react";

const RangeScale = ({
  disabled,
  startLinePoint = 0,
  endLinePoint = 100,
  fieldWidthSize,
  fieldId,
  handleRangeScoreChange,
  rangeValue,
  dataEntryType
}) => {
  const rangeRef = useRef(null);
  const tooltipRef = useRef(null);

  const updateController = (obj) => {
    const thumbPos = getThumbPercentage(obj);
    const thumbPosPX = getThumbPosition(obj);

    if (obj.getAttribute("data-tooltip") !== "false") {
      updateTooltip(tooltipRef.current, obj.value, thumbPosPX, thumbPos);
    } else {
      if (tooltipRef.current) tooltipRef.current.style.display = "none";
    }

    updateTrackColor(obj, thumbPos);
  };

  const getThumbPosition = (obj) => {
    const range = obj.max - obj.min;
    return Math.round(((obj.value - obj.min) / range) * obj.offsetWidth);
  };

  const getThumbPercentage = (obj) => {
    const range = obj.max - obj.min;
    return Math.round(((obj.value - obj.min) / range) * 100);
  };

  const updateTooltip = (tooltip, value, position, percentage) => {
    if (!tooltip) return;
    tooltip.innerHTML = value;
    tooltip.style.left = `${position}px`;

    const tooltipStartPos = 26;
    let tooltipPosFix = percentage / 1.8;
    if (percentage > 0) {
      tooltipPosFix = percentage / 2.2;
    }
    tooltip.style.transform = `translate(-${tooltipStartPos + tooltipPosFix}%, 0)`;
    tooltip.style.display = "inline-block";
  };

  const updateTrackColor = (obj, percentage) => {
    const rangeBg = `linear-gradient(to right, #c7df88 0%, #5b8a2f ${percentage}%, rgb(224, 224, 224) ${percentage}%, rgb(224, 224, 224) 100%)`;
    obj.style.background = rangeBg;
  };

  useEffect(() => {
    const rangeInput = rangeRef.current;

    if (!rangeInput || rangeValue === null || rangeValue === undefined || rangeValue === "") {
      if (tooltipRef.current) tooltipRef.current.style.display = "none";
      if (rangeInput) rangeInput.style.background = "";
      return;
    }

    const handleInput = () => updateController(rangeInput);

    updateController(rangeInput);
    rangeInput.addEventListener("input", handleInput);
    rangeInput.addEventListener("change", handleInput);

    return () => {
      rangeInput.removeEventListener("input", handleInput);
      rangeInput.removeEventListener("change", handleInput);
    };
  }, [rangeValue]);

  return (
    <div style={{ width: fieldWidthSize }} className="custom-rangeslider">
      <div className="hstack">
        <div className="vr"></div>
        <input
          ref={rangeRef}
          className="custom-rangeInput"
          id="range-slider1"
          type="range"
          min={startLinePoint}
          max={endLinePoint}
         disabled={dataEntryType || disabled}
          value={rangeValue ?? startLinePoint}
          style={{
            opacity: disabled ? .6 : 1,
            cursor: disabled ? "not-allowed" : "pointer",
            pointerEvents: disabled ? "none" : "auto",
          }}
          step="1"
          data-tooltip="true"
          aria-controls="rangeTooltip rangeLabel"
          aria-live="polite"
          onChange={
            !dataEntryType || !disabled && typeof handleRangeScoreChange === "function"
              ? (e) =>
                  handleRangeScoreChange(
                    fieldId,
                    "range",
                    "value",
                    e.target.value
                  )
              : undefined
          }
        />

        <div className="vr"></div>
      </div>

      <span ref={tooltipRef} className="custom-rangeslider__tooltip fw-bold">
        {rangeValue ?? startLinePoint}
      </span>

      <span className="custom-rangeslider__label fw-bold">
        <span className="custom-rangeslider__label-min">{startLinePoint}</span>
        <span className="custom-rangeslider__label-max">{endLinePoint}</span>
      </span>
    </div>
  );
};

export default RangeScale;